<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      
      <div class="mb-3">
        <strong> Total: ₹ 0 </strong>
      </div>

      <!-- Table -->
       
         <div class="datatable-outer-container">
            <data-table
                          :columns="exemptTableColumns"
                          :tableData="Exemption17.Section17"
                          :showinrow="true"
                          :withForm="false"
                          :showhistory="false"
                          :showdelete="false"
                          :showedit="false"
                         
                        >
                          <template v-slot:rowcontent="slotprops">
                            <div>
                              <p
                                v-if="slotprops.value.column.key == 'slno'"
                              >{{slotprops.value.index+1}}</p>
                              <p
                                v-if="slotprops.value.column.key == 'particulars'"
                              >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name: slotprops.value.record.name}}</p>
                              <p
                                v-if="slotprops.value.column.key == 'limits'"
                              >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p>
                              <p v-if="slotprops.value.column.key=='planned'">
                                <txt
                                  type="number"
                                  :disable="false"
                                  :name="'explannedvalue'+slotprops.value.index"
                                  v-model="Exemption17.Section17[slotprops.value.index].planned"
                                  v-validate="{required: true, regex:/^[1-9]{1}[0-9]{6}$/}"
                                />
                                <!-- <span v-else>-</span> -->
                              </p>
                              
                            </div>
                          </template>
                        </data-table>
        </div>
        <!-- End -->
      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="goBack"/>
              <btn text="Save" type="primary" @click="submitData"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  get_axios_file_instance,
  api_variables,
} from "@/apis/variables.js";

export default {
  name: "exemptionUnderSectionSeventeen",
  props: {
    section17:{
      type:Object
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
       Exemption17: {
        Section17: []
      },
       exemptTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Yearly limits",
          key: "limits"
        },
        {
          label: "Planned",
          key: "planned"
        }
      ],
    };
  },
  computed: {
   ...mapState({
     // incomeTaxData: state => state.onboard.statutoryinfo.incometax.data,
      //globalData: state => state.globalapi.globalData.data
    }),
      
   le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },

  },

  mounted() {
    this.showSuccessMsg = false;
    this.load();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    load(){
       //console.log("data check...............",this.section17);
       let data=this.section17;
         this.Exemption17.Section17 = [];
          data.Section17.forEach(element => {
            this.Exemption17.Section17.push({
              planned: element.planned ? element.planned : 0,
             
              ...element
            });
          });
          ////console.log("after push data",this.Exemption17.Section17);
    },
    submitData(){
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxdeclarationplan`,
          });
          this.$emit("section17update",this.Exemption17)
    },

    // Add here code for cancel button to hide popup By Bhushan 
    goBack() {
      this.$emit('back');
    }
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}
        
.datatable-outer-container table.datatable {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
            font-family: Montserrat;
            margin-bottom: 4px;
}
        
        .datatable-outer-container table.datatable .header-row {
            background-color: white;
            height: 54px;
        }
        
        .datatable-outer-container table.datatable .header-row th {
            background-color: #f0f1f5;
            border-bottom: 1px solid #34c0be;
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .header-row th .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .inactiveCols {
            opacity: 0.03;
            background-color: #a2a1a1;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader {
            background-color: #ffffff;
            -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
            box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th {
            padding: 0 8px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span {
            border-right: 1px solid #ececec;
            padding: 0px 18px 0px 15px;
            display: inline-block;
            vertical-align: middle;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
            padding: 10px 10px 7px 10px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
            text-align: right;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
            position: absolute;
            right: 10px;
            top: 2px;
        }
        
        .datatable-outer-container table.datatable .record-row {
            height: 60px;
            border-bottom: none;
        }
        
        .datatable-outer-container table.datatable .record-row:nth-child(odd) {
            background-color: #fff;
        }
        
        .datatable-outer-container table.datatable .record-row.selectedRecord {
            background-color: #E9F9F8;
            opacity: 0.9;
        }
        
        .datatable-outer-container table.datatable .record-row td {
            padding: 6px 8px;
            color: #646464;
            font-weight: 500;
        }
        
        .datatable-outer-container table.datatable .record-row td .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .record-row .actions {
            width: 10%;
            padding: 10px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item {
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item p {
            width: 100%;
            margin-bottom: 0px;
        }
        
        .datatable-outer-container table.datatable .record-row .action-img {
            display: inline-block;
            cursor: pointer;
            opacity: 0;
        }
        
        .datatable-outer-container table.datatable .record-row:hover .action-img {
            opacity: 1;
        }

.inputbox{
   width: 149px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}
</style>
